/** Connection health toasts: the companion link and the AI CLI's health. */
export default {
  companionDisconnectedTitle: "Denker is disconnected",
  reconnect: "Reconnect",
  companionRestartEscalated:
    "Reconnection keeps failing — quit and reopen Denker.",
  companionStartFailed:
    "Denker couldn’t start its local companion. Reconnect to try again.",
  companionWaiting:
    "Your agents can’t run until the local companion reconnects.",
  serverUnreachableTitle: "Connection failed",
  serverUnreachableBody: "Could not reach the server.",

  actionInstall: "Install",
  actionSignIn: "Sign in",
  actionUpdate: "Update",
  actionCopyCommand: "Copy command",
  actionOpenSignInPage: "Open sign-in page",
  actionOpenTerminal: "Open terminal",

  missingTitle: "{name} isn’t installed",
  missingBody:
    "Denker can’t find the AI CLI you selected. Install it to keep your agents working.",
  signedOutTitle: "{name} isn’t signed in",
  signedOutBody: "Sign in so your agents can keep working.",
  updateVersionTitle: "{name} {version} is available",
  updateTitle: "{name} update available",
  updateBody: "Update to get the latest models and fixes.",
  authExpiredTitle: "{name} sign-in expired",
  authExpiredBody:
    "Your last request was rejected. Sign in again to keep your agents working.",

  connectedAgain: "Your agents can use {name} again.",
  setupReady: "{name} is ready",
  setupUnfinished: "{name} setup didn’t finish",
  setupTitle: "{name} setup",
  commandCopiedTitle: "Command copied",
  commandCopiedBody: "Paste it into your terminal: {command}",
  copyFailedTitle: "Couldn’t copy the command",
  copyFailedBody: "Run this in your terminal: {command}",
} as const;
